import React, { Component } from 'react';
import '../App.css';
import Form from './Form.js';
import List from './List.js';
import firebase from './firebase.js';
import About from './About.js';

class App extends Component {

  constructor(props){
    super(props);
    this.state={
      username: '',
      tasks: [],
      task: {
        title:'',
        user:'',
        score:0
      }
    }
  }

  componentDidMount(){
    const tasksf=firebase.database().ref(`openwall`);
    tasksf.on('value',(snapshot)=>{
      let items=snapshot.val();
      items.sort(function(a,b){
        return b.score-a.score;
      });
      //console.log(tasks);
      let newState=[];
      for(let item in items){
        newState.push({
          id: items[item].id,
          title: items[item].title,
          user: items[item].user,
          score: items[item].score
        });
      }
      this.setState({
        tasks: newState
      });
    });
  }

  createTask=(task)=>{
    let id=this.state.tasks.length;
    if(task.title!==''){
      task.id=id;
      if(task.user==='')
        task.user='Anonymous';
      const tasksf=firebase.database().ref(`openwall`);
      let tasks=this.state.tasks;
      tasks.push(task);
      tasksf.set(tasks);
    }
  }

  removeTask=(id)=>{
   let taskf=firebase.database().ref(`openwall/${id}`);
   taskf.remove();
  }

  upvote=(id)=>{
    let tasksf=firebase.database().ref(`openwall`);
    let tasks=this.state.tasks;
    for(let i=0;i<tasks.length;i++){
      if(tasks[i].id===id)
        tasks[i].score++;
    }
    this.setState({
      tasks
    })
     //console.log(this.state.tasks);
     tasksf.set(this.state.tasks);
  }

  downvote=(id)=>{
    let tasksf=firebase.database().ref(`openwall`);
    let tasks=this.state.tasks;
    for(let i=0;i<tasks.length;i++){
      if(tasks[i].id===id)
        tasks[i].score--;
    }
    this.setState({
      tasks
    })
     //console.log(this.state.tasks);
     tasksf.set(this.state.tasks);
  }

  render() {
    return (
      <div className="App">
      <div className="TopBar">
          <div className="AppTitle"><h1>TheOpenWall</h1></div>
          <div className="author"><a href="https://surajk95.github.io/"target="_blank">by surajk95</a></div>
          <div className="OuterForm">
            <Form onClickFunction={this.createTask}/>
          </div>
      </div>
      <List
        tasks={this.state.tasks}
        removeTask={this.removeTask}
        upvote={this.upvote}
        downvote={this.downvote}
      />
      <About/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App.js